module.exports = __webpack_public_path__ + "img/gune_2.d22c8237.jpg";